export default "__VITE_ASSET__0kMTn9Hi__"